import { FC } from 'react';

import useToggleModal from '@/hooks/useToggleModal';
import Heading from '@/components/common/Heading';
import Image from 'next/image';
import Button from '@/components/common/Button/Button';
import FormModal from '../FormModal/FormModal';
import ClientOnly from '@/components/common/ClientOnly';

import { InnerHeroType } from '@/types';

interface IInnerHeroProps {
  innerHero: InnerHeroType;
}

const InnerHero: FC<IInnerHeroProps> = ({
  innerHero: { text, title, img, button },
}) => {
  const { isOpen, openModal, closeModal, handleKeyDown, handleBackdropClick } =
    useToggleModal();

  return (
    <>
      <div className=" md:flex items-center">
        <div className=" flex flex-col md:flex-1 max-md:py-[30px] mb-5 md:mb-0 ">
          <Heading
            headingLevel="h1"
            className=" mb-[1.5em] 
            animate-text bg-gradient-to-r from-[--accent-color] via-[#7928CA] to-[#FF4D4D] bg-clip-text text-transparent text-4xl leading-[2.8rem] md:text-5xl lg:font-extrabold lg:leading-[1.2em] lg:mb-[0.5em]
              "
          >
            {title}
          </Heading>
          <p className=" custom-p mb-[1.5em] font-medium text-[1.5em] lg:text-[1.5em] lg:w-[80%] leading-[1.3] text-black">
            {text}
          </p>
          <Button onClick={openModal} className="mr-auto">
            {button}
          </Button>
        </div>
        <div className="md:flex-1 ">
          <Image
            className=" block m-auto md:ml-auto xl:w-[65%]"
            src={`/assets/icons/heroImg/${img}`}
            width={500}
            height={500}
            alt="Hero"
            priority
          />
        </div>
      </div>
      <ClientOnly>
        {isOpen && (
          <FormModal
            handleKeyDown={handleKeyDown}
            handleBackdropClick={handleBackdropClick}
            closeModal={closeModal}
          />
        )}
      </ClientOnly>
    </>
  );
};

export default InnerHero;
